<script setup lang="ts">
import { TheSnackbar } from '@/components/';
import { useRoute } from 'vue-router';

const { visibility, component, permanent, temporary, componentProps, location, closeDrawer } = useNavigationDrawer();

const route = useRoute();
</script>
<template>
  <v-layout class="default-layout">
    <v-navigation-drawer
      v-model="visibility"
      :permanent="permanent"
      :temporary="temporary"
      :location="location"
      width="259"
    >
      <component v-if="component" :is="component" v-bind="componentProps" @close="closeDrawer" />
    </v-navigation-drawer>

    <v-main class="default-layout__page page-background">
      <NuxtPage :page-key="(route) => route.path" />
      <TheSnackbar />
    </v-main>
  </v-layout>
</template>
<style lang="scss" scoped>
.default-layout {
  &__page {
  }
}

.v-navigation-drawer {
  background: transparent;
}
</style>
